import React, { useState } from 'react';
import { PageLayout } from '../shared/PageLayout';
import { ConnectionBadge } from '../shared/ConnectionBadge';
import { SeedStatus } from '../../../developer/diagnostics/SeedStatus';
import { TaxonomyGovernanceDiagnostics } from '../../../developer/diagnostics/TaxonomyGovernanceDiagnostics';
import { computeLiveSystemStats } from '../../../../governance/systemStats';
import { DatabaseIcon, GitBranchIcon, CpuIcon } from 'lucide-react';
const tabs = [{
  id: 'seeds',
  label: 'Seed Status',
  icon: <DatabaseIcon className="w-4 h-4" data-id="element-822" />
}, {
  id: 'taxonomy',
  label: 'Taxonomie',
  icon: <GitBranchIcon className="w-4 h-4" data-id="element-823" />
}, {
  id: 'system',
  label: 'Systeem Info',
  icon: <CpuIcon className="w-4 h-4" data-id="element-824" />
}] as const;
type TabId = (typeof tabs)[number]['id'];
function SystemInfoPanel() {
  const stats = computeLiveSystemStats();
  const rows = [{
    label: 'Totaal vragen',
    value: stats.totalQuestions?.toLocaleString('nl') ?? '—'
  }, {
    label: 'Seed bestanden',
    value: stats.totalSeeds?.toString() ?? '—'
  }, {
    label: 'Build omgeving',
    value: typeof import.meta !== 'undefined' && import.meta.env?.MODE ? import.meta.env.MODE : 'development'
  }, {
    label: 'React versie',
    value: '18.x'
  }, {
    label: 'TypeScript',
    value: 'Strict mode'
  }];
  return <div className="space-y-4" data-id="element-825">
      <div className="bg-white rounded-xl border border-gray-200 overflow-hidden" data-id="element-826">
        <div className="px-5 py-4 border-b border-gray-100" data-id="element-827">
          <h3 className="text-sm font-semibold text-gray-900" data-id="element-828">
            Systeem statistieken
          </h3>
        </div>
        <div className="divide-y divide-gray-50" data-id="element-829">
          {rows.map(row => <div key={row.label} className="px-5 py-3 flex items-center justify-between" data-id="element-830">
              <span className="text-sm text-gray-600" data-id="element-831">{row.label}</span>
              <span className="text-sm font-medium text-gray-900 font-mono" data-id="element-832">
                {row.value}
              </span>
            </div>)}
        </div>
      </div>
    </div>;
}
export function DeveloperToolsPage() {
  const [activeTab, setActiveTab] = useState<TabId>('seeds');
  return <PageLayout title="Developer Tools" description="Seed status, taxonomie diagnostics en systeem informatie" actions={<ConnectionBadge status="live" data-id="element-834" />} data-id="element-833">
      {/* Tabs */}
      <div className="flex gap-1 mb-6 bg-gray-100 rounded-lg p-1 w-fit" data-id="element-835">
        {tabs.map(tab => <button key={tab.id} onClick={() => setActiveTab(tab.id)} className={`flex items-center gap-1.5 px-3 py-1.5 text-sm rounded-md transition-colors ${activeTab === tab.id ? 'bg-white text-gray-900 font-medium shadow-sm' : 'text-gray-500 hover:text-gray-700'}`} data-id="element-836">
            {tab.icon}
            {tab.label}
          </button>)}
      </div>

      {/* Tab content */}
      {activeTab === 'seeds' && <div className="bg-white rounded-xl border border-gray-200 overflow-hidden" data-id="element-837">
          <div className="px-5 py-4 border-b border-gray-100" data-id="element-838">
            <h3 className="text-sm font-semibold text-gray-900" data-id="element-839">
              Seed bestanden status
            </h3>
            <p className="text-xs text-gray-500 mt-0.5" data-id="element-840">
              Overzicht van alle geladen seed bestanden en hun vraagaantallen
            </p>
          </div>
          <div className="p-4" data-id="element-841">
            <SeedStatus data-id="element-842" />
          </div>
        </div>}

      {activeTab === 'taxonomy' && <div className="bg-white rounded-xl border border-gray-200 overflow-hidden" data-id="element-843">
          <div className="px-5 py-4 border-b border-gray-100" data-id="element-844">
            <h3 className="text-sm font-semibold text-gray-900" data-id="element-845">
              Taxonomie governance diagnostics
            </h3>
            <p className="text-xs text-gray-500 mt-0.5" data-id="element-846">
              Analyse van de taxonomie structuur en governance regels
            </p>
          </div>
          <div className="p-4" data-id="element-847">
            <TaxonomyGovernanceDiagnostics data-id="element-848" />
          </div>
        </div>}

      {activeTab === 'system' && <SystemInfoPanel data-id="element-849" />}
    </PageLayout>;
}